import { Logout, SetDriver } from 'src/constants/actionTypes'
import { Action } from 'src/utils/reduxUtils'
import { DriverState } from './types'

const getInitialState = (): DriverState => ({
  driver: null,
})

export const driverReducer = (
  state: DriverState = getInitialState(),
  action: Action<any>,
): DriverState => {
  switch (action.type) {
    case SetDriver.type.SUCCESS:
      return {
        ...state,
        driver: action.payload,
      }
    case Logout.type.SUCCESS:
      return getInitialState()
    default:
      return state
  }
}
